<script>
  export default {
    props: ['bookings', 'selectedDate', 'occations','otherOccations', 'startDate'],
    data() {
      return {
        currentDate: new Date(), 
        selectEndTime: false
      };
    },
    created() {
    if(this.selectedDate.date_formatted)
      {
          this.currentDate = new Date(this.selectedDate.date_formatted);
      }
    },
    methods: {
      prevWeek() {
        this.currentDate.setDate(this.currentDate.getDate() - 7);
        this.currentDate = new Date(this.currentDate);
      },
      nextWeek() {
        this.currentDate.setDate(this.currentDate.getDate() + 7);
        this.currentDate = new Date(this.currentDate);
      }, 
      getOccasionClass(day, time)
      {       
        if(this.checkIfDateAndTimeMatches(this.selectedDate, day, time)) {
            return 'highlight occupied';
        }

        var self = this;
        var hasOccation = false;
        this.occations.forEach(x => {
            if(self.checkIfDateAndTimeMatches(x, day, time))
            {
                hasOccation = true;
            }
        });
        if(hasOccation) { return 'highlight-faded occupied'}
        
        var self = this;
        hasOccation = false;
        this.otherOccations.forEach(x => {
            if(self.checkIfDateAndTimeMatches(x, day, time))
            {
                hasOccation = true;
            }
        });
        if(hasOccation) { return 'highlight-other-faded occupied'}

        return '';
      },
      checkIfDateAndTimeMatches(occationDay, calenderDay, time) {
        if(occationDay.date_formatted == calenderDay.date) {           
            if((new Date(occationDay.date_formatted +' '+ time.timeLabel) >= new Date(occationDay.date_formatted + ' ' + occationDay.start_time)) &&
             (new Date(occationDay.date_formatted +' '+ time.timeLabel) < new Date(occationDay.date_formatted + ' ' + occationDay.end_time)))
                return true;
             
            return false;
        }
      },
      selectStartTime(day, time, nextHour, event) {
        //do nothing if user clicks on occupied area
        if(event.srcElement.className.includes('occupied')) {
          return;
        }

        if(!this.selectEndTime || this.selectedDate.date_formatted != day.date) {
          this.selectedDate.start_time = time.timeLabel;
          this.selectedDate.end_time = nextHour.timeLabel;
          this.selectEndTime = true;
        } else {
          this.selectedDate.end_time = nextHour.timeLabel;
          this.selectEndTime = false;
        }
        this.selectedDate.date_formatted = day.date;
      },
      updateDateTime() {
            const baseDate = this.selectedDate.date_formatted;
            this.selectedDate.start_date = `${baseDate}T${this.selectedDate.start_time}:00`;
            this.selectedDate.end_date = `${baseDate}T${this.selectedDate.end_time}:00`;
       },    
    },
    computed: {
      startOfCurrentWeek() {
        const date = new Date(this.currentDate);
        const day = date.getDay();
        const diff = (day === 0 ? -6 : 1) - day; // monday is first day in sweden
        date.setDate(date.getDate() + diff);
        date.setHours(0, 0, 0, 0);
        return date;
      },
      weekDays() {
        return Array.from({ length: 7 }, (_, i) => {
          const date = new Date(this.startOfCurrentWeek);
          date.setDate(date.getDate() + i);
          return { date: date.getFullYear() + '-' + String(date.getMonth()+1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0'), labelDate: date.toLocaleDateString('sv-SE', { weekday: 'long', day: 'numeric', month: 'numeric' }) };
        });
      },
      timeSlots() {
        const slots = [];
        for (let hours = 8; hours < 24; hours++) {
            slots.push({ timeLabel: `${String(hours).padStart(2, '0')}:00` }); // Full hour
            slots.push({ timeLabel:`${String(hours).padStart(2, '0')}:30` }); // Half hour
        }
        slots.push({ timeLabel:`00:00` })
        return slots;
    },
      currentWeek() {
        const date = new Date(this.startOfCurrentWeek);
        const oneJan = new Date(date.getFullYear(), 0, 1);
        const weekNumber = Math.ceil((((date - oneJan) / 86400000) + oneJan.getDay() + 1) / 7);
        return weekNumber;
      }
    },
    watch: {
        // Watch start_time and end_time
        "selectedDate.start_time": function () {
        this.updateDateTime();
        },
        "selectedDate.end_time": function () {
        this.updateDateTime();
        },
    },
  };
  </script>
  <template>
    <div class="calendar">
      <div class="header">
        <button class="btn btn-gray" @click="prevWeek">Föregående vecka</button>
        <h1>Vecka {{ currentWeek }}, {{ currentDate.getFullYear() }}</h1>
        <button class="btn btn-gray" @click="nextWeek">Nästa vecka</button>
      </div>
      <div class="grid">
        <div class="time-column">
        <div class="CalenderWeeks-day-label"></div>
        <div v-for="(time, index) in timeSlots" :key="time" class="time-label" :style="{'border-top-style': index % 2 === 1 ? 'dashed' : '' }">
          {{ index % 2 === 0 ? time.timeLabel : '' }}
        </div>
      </div>
        <div v-for="day in weekDays" :key="day" class="day-column">
            <div class="CalenderWeeks-day-label font-color">{{ day.labelDate }}</div>
          <div v-for="(time,index) in timeSlots" :key="time" class="time-slot" :style="{'border-top-style': index % 2 === 1 ? 'dashed' : '' }" :class="getOccasionClass(day, time)" @click="selectStartTime(day, time, timeSlots[index+1], $event)">
            <span v-if="selectedDate.date_formatted == day.date && selectedDate.start_time == time.timeLabel"> {{ selectedDate.start_time }} - {{ selectedDate.end_time }}</span>
            <span v-else>
                <span v-for="o in occations" :key="o">
                    <span class="occupied" v-if="o.date_formatted == day.date && o.start_time == time.timeLabel">{{ o.name }}, {{ o.start_time }} - {{ o.end_time }}</span>
                </span>
                <span v-for="o in otherOccations" :key="o">
                    <span class="CalenderWeeks-course-title occupied" v-if="o.date_formatted == day.date && o.start_time == time.timeLabel">{{ o.start_time }} - {{ o.end_time }}, {{ o.course_name}} </span>
                </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  <style scoped>
    .CalenderWeeks-course-title {     
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: block;
    }
    .CalenderWeeks-day-label {
        height:30px;
        min-width:20px;
        font-weight:500;
        font-size: 13px;
    }
  .calendar {
    padding:20px;
    width: calc(100% - 40px);
    margin: auto;
    background-color: white;
    border-radius: 16px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  .grid {
    display: flex;
    overflow-x: auto;
  }
  .time-column {
    display: flex;
    flex-direction: column;
    width: 60px;
    text-align: right;
    font-size: 12px;
  }
  .day-column {
    flex: 1;
    border-left: 1px solid #ddd;
    min-width: 100px;
  }
  .time-slot {
    height: 17px;
    border-top: 1px solid #ddd;
    text-align: center;
    font-size: 10px;
    cursor:pointer;
    position:relative;
  }
  
  .time-label {
    height: 17px;
    border-top: 1px solid #ddd;
    text-align: center;
    font-size: 10px;
  }

  .highlight {
        background-color: #f59eee;
        border-top-color: #f59eee;
        
    }
  
  .highlight-faded {
    background-color: #f9d5f8;
    opacity: 1;
    background: repeating-linear-gradient( -45deg, #fabdf9, #fabdf9 4px, #f9d5f8 2px, #f9d5f8 13px);
    cursor:not-allowed;
    }
  
  .highlight-other-faded {
    background-color: #e7e7e7;
    opacity: 1;
    background: repeating-linear-gradient( -45deg, #dad9d9, #dad9d9 4px, #e7e7e7 2px, #e7e7e7 13px);
    cursor:not-allowed;
  }
  </style>
  